import * as React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  // Calculate percentage (1-based index for display logic)
  const percentage = Math.round(((current + 1) / total) * 100);

  return (
    <div className='mb-6 w-full'>
      <div className='mb-2 flex justify-between'>
        {/*
           Left Label: "Question X of Y"
           Mobile: 12px (text-progress-label-mobile)
           Desktop: 15px (md:text-question-progress)
        */}
        <span className='font-sans text-progress-label-mobile font-medium text-gray-540 md:text-question-progress'>
          Question {current + 1} of {total}
        </span>

        {/*
           Right Label: "X% Complete"
           Mobile: 14px Bold (text-progress-value-mobile font-bold)
           Desktop: 15px Medium (md:text-question-progress md:font-medium)
        */}
        <span className='font-sans text-progress-value-mobile font-bold text-gray-540 md:text-question-progress md:font-medium'>
          {percentage}% Complete
        </span>
      </div>
      {/* Track: Height 6px, Radius 20px, BG #D9D9D9 (gray-350) */}
      <div className='h-[6px] w-full overflow-hidden rounded-20 bg-gray-350'>
        {/* Fill: Height 6px, Radius 20px, BG #BFB0F8 */}
        <div
          className='h-full rounded-20 bg-brand-300 transition-all duration-300 ease-out'
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
